export default __webpack_public_path__ + "static/ilustration-about-1-c874987861fa07bcb38ebf4fd69ac0c6.png";